import EmailDocsFeature from '../../features/docs/email-feature';

export default function EmailDocsPage() {
  return <EmailDocsFeature />;
}
